// 27-10 
import React, { useState, useEffect, useContext, useRef } from "react";
import { Form } from "react-router-dom";
import Application from "../../../StateContext/Application";
import {
  Cancel32,
  DeleteRed32,
  EditBlueBlue32,
  submit,
  Tax32,
  UpdateWhite32,
  EditIcon,
  DeleteIcon,
  Edit32WHITE,
  Delete32WHITE,
} from "../../../../../public/LoginImages/importimages";
import "../master.css";

const Banks = () => {
  const statecalls = useContext(Application);
  const { BankMaster, DeductionOperation } = statecalls;
  const [isHovered, setIsHovered] = useState(false);
  // 12-10 for hover
  const [hoveredEditId, setHoveredEditId] = useState(null);
  const [hoveredDeleteId, setHoveredDeleteId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");//12-10 for search
  const [fetchBanksDetails, setFetchBankDetails] = useState([]);
  const [formData, setFormData] = useState({
    BankName: "",
    AccountNumber: "",
    IFSCCode: "",
    Branch: "",
    AccountHodlerName: "",
    UseFor: "",
    DeductionID: "",
  });

  const [formErrors, setFormErrors] = useState({
    BankName: "",
    AccountNumber: "",
    IFSCCode: "",
    Branch: "",
    AccountHodlerName: "",
    UseFor: "",
    DeductionID: "",
  });

  const [tableData, setTableData] = useState([]);
  const [editId, setEditId] = useState(null);
  const [isIfscValid, setIsIfscValid] = useState(null);
  const [ifscMessage, setIfscMessage] = useState("");
  const formdataref = useRef(null);
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5;



  // 27-10 for automatic fetch bank and branch name after ifsc code
  const latestIfscRef = useRef("");

const validateIfsc = async (code, autoFill = true) => {
  const IFSC = (code || "").trim().toUpperCase();
  latestIfscRef.current = IFSC;

  if (!IFSC) {
    setIsIfscValid(null);
    setIfscMessage("IFSC Code is required");
    return;
  }

  // Don't call the API until the code is complete and correctly formatted
  if (IFSC.length < 11) {
    setIsIfscValid(false);
    setIfscMessage("IFSC Code must be 11 characters");
    return;
  }
  if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(IFSC)) {
    setIsIfscValid(false);
    setIfscMessage("Invalid IFSC Code");
    return;
  }

  try {
    const response = await fetch(`https://ifsc.razorpay.com/${IFSC}`);

    // Ignore the result if the user has already changed the IFSC
    if (latestIfscRef.current !== IFSC) return;

    if (response.ok) {
      const info = await response.json();
      setIsIfscValid(true);
      setIfscMessage("Correct");

      if (autoFill) {
        setFormData((prev) => ({
          ...prev,
          BankName: info.BANK || prev.BankName,
          Branch: info.BRANCH || prev.Branch,
        }));
        setFormErrors((prev) => ({ ...prev, BankName: "", Branch: "" }));
      }
    } else {
      setIsIfscValid(false);
      setIfscMessage("Invalid IFSC Code");
    }
  } catch (error) {
    if (latestIfscRef.current !== IFSC) return;
    setIsIfscValid(false);
    setIfscMessage("Error validating IFSC Code");
    console.error("Error validating IFSC code:", error);
  }
};
  //27/10
  const getbudget = async () => {
    let data = await BankMaster("get");
    if (data && Array.isArray(data)) {
      const latestFirst = [...data].sort((a, b) => Number(b.id) - Number(a.id));
      setTableData(latestFirst);
      setCurrentPage(1);
    } else {
      setTableData([]);
      console.error("Error: Data is not an array or undefined.");
    }
  };

  useEffect(() => {
    getbudget();
  }, []);

  const handleInputChange = (e) => {
    // const { name, value } = e.target;
    // 27-10
     const { name } = e.target;
  let value = e.target.value;
    let errorMessage = "";
    const validUserName = /^[a-zA-Z0-9 ]*$/;
    if (name === "BankName" && !validUserName.test(value)) {
      errorMessage = "Only alphanumeric characters and spaces are allowed.";
    }
    const validAccountNumber = /^[0-9]*$/;
    if (name === "AccountNumber" && !validAccountNumber.test(value)) {
      errorMessage = "Only numeric characters are allowed.";
    }
    const validAccountHolderName = /^[a-zA-Z ]*$/;
    if (name === "AccountHodlerName" && !validAccountHolderName.test(value)) {
      errorMessage = "Only alphabets and spaces are allowed.";
    }
    if (name === "Branch" && !validUserName.test(value)) {
      errorMessage = "Only alphanumeric characters and spaces are allowed.";
    }
    // if (name === "IFSCCode") {
    //   validateIfsc(value);
    // }
    // 27-10
  
    if (name === "IFSCCode") {
      value = value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 11);
      validateIfsc(value);
    }
    setFormData({
      ...formData,
      [name]: value,
    });
    setFormErrors({
      ...formErrors,
      [name]: errorMessage,
    });

    //26/10
    if (value.trim() !== "" && !errorMessage) {
      setFormErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    } else {
      setFormErrors((prev) => ({
        ...prev,
        [name]: errorMessage,
      }));
    }
    setFormErrors((prev) => ({
      ...prev,
      [name]: errorMessage,
    }));

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const errors = {};
      if (!formData.BankName) errors.BankName = "Bank Name is required.";
      if (!formData.AccountNumber)
        errors.AccountNumber = "Account Number is required.";
      if (!formData.IFSCCode || !isIfscValid)
        errors.IFSCCode = "Valid IFSC Code is required.";
      if (!formData.Branch) errors.Branch = "Branch Name is required.";
      if (!formData.AccountHodlerName)
        errors.AccountHodlerName = "Account Holder Name is required.";
      if (!formData.UseFor)
        errors.UseFor = "Please select an option for Deduction Type.";
      if (!formData.DeductionID)
        errors.DeductionID = "Please select an option for Deduction Type.";
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
        return;
      }

      let action = editId ? "edit" : "insert";
      let payload = editId ? { ...formData, id: editId } : formData;
      console.log("Action:", action);
      console.log("Payload:", payload);

      let data = await BankMaster(action, payload);
      console.log("Response Data:", data);

      alert(data.message);
      getbudget();
      setEditId(null);
      setFormData({
        BankName: "",
        AccountNumber: "",
        IFSCCode: "",
        Branch: "",
        AccountHodlerName: "",
        UseFor: "",
        DeductionID: "",
      });
      setIfscMessage("");

      getbudget();
    } catch (err) {
      alert(err);
      console.log(err);
    }
  };


  //27/10
  const handleEdit = (item) => {

    const matchedDeduction =
      fetchBanksDetails.find(
        (d) => String(d.DeductionID) === String(item.DeductionID)
      ) ||
      fetchBanksDetails.find((d) => d.Deduction_Name === item.UseFor);

    setFormData({
      BankName: item.Bank_Name,
      AccountNumber: item.Account_Number,
      IFSCCode: item.IFSC_CODE,
      Branch: item.Branch_Name,
      AccountHodlerName: item.AccountHodlerName,
      UseFor: matchedDeduction ? matchedDeduction.Deduction_Name : item.UseFor,
      DeductionID: matchedDeduction ? String(matchedDeduction.DeductionID) : "",
    });

    setFormErrors({
      BankName: "",
      AccountNumber: "",
      IFSCCode: "",
      Branch: "",
      AccountHodlerName: "",
      UseFor: "",
      DeductionID: "",
    });

    setEditId(item.id);
    setIsIfscValid(null);
    setIfscMessage("");
    // validateIfsc(item.IFSC_CODE);
        validateIfsc(item.IFSC_CODE, false);

    formdataref.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const handleDelete = async (e, id) => {
    e.preventDefault();
    console.log("ID DELETE", id);
    if (window.confirm("Are you sure you want to delete this bank?")) {
      let data = await BankMaster("delete", id);
      if (data && data.message === "Bank Deleted Successfully") {
        alert("Deleted successfully!");
        getbudget();
      } else {
        alert("Delete failed");
      }
    }
  };
  // const resetData = () => {
  //   formdataref.current.reset();
  //   setFormData([]);
  // };

  //27/10
  const resetData = () => {
    const wasEditing = !!editId;

    setFormData({
      BankName: "",
      AccountNumber: "",
      IFSCCode: "",
      Branch: "",
      AccountHodlerName: "",
      UseFor: "",
      DeductionID: "",
    });

    setFormErrors({
      BankName: "",
      AccountNumber: "",
      IFSCCode: "",
      Branch: "",
      AccountHodlerName: "",
      UseFor: "",
      DeductionID: "",
    });

    setEditId(null);
    setIsIfscValid(null);
    setIfscMessage("");

    alert(wasEditing ? "Update cancelled successfully." : "Form cleared successfully.");
  };

  const FetchBanksDetailInitally = async () => {
    try {
      let res = await DeductionOperation(
        "null",
        "fetchAllDeductionTypeDetails",
      );
      setFetchBankDetails(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchBanksDetailInitally();
    getbudget();
  }, []);

  const changeOptions = (e, id) => {
    e.preventDefault();

    let res = fetchBanksDetails.filter((item) => item.DeductionID == id);
    console.log(res[0].Deduction_Name);

    setFormData({
      ...formData,
      UseFor: res[0].Deduction_Name,
      DeductionID: id,
    });
  };

  // console.log("Form Data I selected :: ", formData)
  console.log("Table Data i get :: ", tableData);


  // 12-10 for search
  const filteredTableData = tableData.filter((item) =>
    [
      item.Bank_Name,
      item.Account_Number,
      item.IFSC_CODE,
      item.Branch_Name,
      item.AccountHodlerName,
      item.UseFor,
    ].some((value) =>
      String(value ?? "")
        .toLowerCase()
        .includes(searchTerm.trim().toLowerCase())
    )
  );

  

  // 12-10 for search
  const totalPages = Math.ceil(
    filteredTableData.length / recordsPerPage
  );

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  const currentTableData = filteredTableData.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const getPageNumbers = (currentPage, totalPages) => {
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    // Starting pages
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Last pages
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    // Middle pages
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages,
    ];
  };

  return (
     
     <div
       style={{
         // marginLeft: "18.5rem",
         // // transition: "margin-left 0.3s ease",
         // backgroundColor: "#efecff", // full width background
         // minHeight: "100vh", // covers the full height
         // width: "100%", // full width coverage
         // display: "flex",
         // flexDirection: "column",
         // justifyContent: "center",
         // alignItems: "center",
         // padding: "30px", // spacing from top
         // boxSizing: "border-box",
         // overflowY: "auto",
 
         background: "white",
         width: "97%",
         maxHeight: "90vh",
         // minHeight: '100vh',
         transition: "margin-left 0.3s ease",
         overflowY: "auto",
         msOverflowStyle: "none", // IE & Edge
         scrollbarWidth: "none",
 
         padding: 40,
         fontFamily: "Inter, sans-serif",
       }}
     >
 {/* //3/11 */}
       <style>{`.sticky-table-wrap thead th {
   position: sticky !important;
   top: 0 !important;
   z-index: 5 !important;
   background-color: #2D79DB !important;
   color: white;
 }`
 }</style>
       {/* 12-10 for seach */}
       {editId && (
         <div
           style={{
             width: "100%",
             maxWidth: "1200px",
             padding: "12px 18px",
             marginBottom: "15px",
             backgroundColor: "#f3f8fd",
             border: "1px solid #b7d5f0 ",
             borderRadius: "8px",
             fontWeight: "600",
           }}
         >
           Update Bank Details
         </div>
       )}
      {/* //30/10 */}
        <h5
           style={{
             paddingRight: "10px",
             paddingBottom: "10px",
             marginBottom: "20px",
             fontWeight: "700",
             color: "black",
             textAlign: "left",
             width: "100%",
           }}
         >
           <img
             src={"/Bank-Master-32.png"}
             alt="Project Icon"
             style={{ marginRight: "5px", width: 28, height: 28 }}
           />
           Bank Master
         </h5>
 
       <Form
         onSubmit={handleSubmit}
         ref={formdataref}
         style={{
           // marginLeft: "20px",
           display: "flex",
           flexDirection: "column",
           justifyContent: "center",
           alignItems: "center",
           // width: "100%",
           // maxWidth: "1130px",
           backgroundColor: "#ffffff",
           boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
           borderRadius: "10px",
           padding: "20px",
         }}
       >
        
 
 {/* //30/10 */}
         <div
           style={{
             width: "100%",
             maxWidth: "1200px",
             backgroundColor: "#EEF3F8",
             boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
             borderRadius: "10px",
             padding: "30px",
           }}
         >
           <div
             style={{
               display: "grid",
               gap: "20px",
               width: "100%",
               // margin: "20px 0",
               gridTemplateColumns: "1fr 1fr", // exactly 2 columns
             }}
           >
             <div style={{ display: "flex", flexDirection: "column" }}>
               <label style={{ fontWeight: "700", marginBottom: "10px", fontSize:"14px" }}  >
                 Bank Name
               </label>
               <input
                 type="text"
                 className="form-control"
                 name="BankName"
                 style={{
                   border: "1px solid #ccc",
                   borderRadius: "5px",
                   padding: "10px",
                   width: "90%",
                 }}
                 value={formData.BankName}
                 onChange={handleInputChange}
                                 readOnly={isIfscValid === true}
               />
               {formErrors.BankName && (
                 <small style={{ color: "red", fontWeight: "bold" }}>
                   {formErrors.BankName}
                 </small>
               )}
             </div>
 
             <div style={{ display: "flex", flexDirection: "column" }}>
               <label
                style={{ fontWeight: "700", marginBottom: "10px", fontSize:"14px" }}
               >
                 Account Number
               </label>
               <input
                 type="text"
                 className="form-control"
                 name="AccountNumber"
                 style={{
                   border: "1px solid #ccc",
                   borderRadius: "5px",
                   padding: "10px",
                   width: "90%",
                 }}
                 value={formData.AccountNumber}
                 onChange={handleInputChange}
               />
               {formErrors.AccountNumber && (
                 <small style={{ color: "red", fontWeight: "bold" }}>
                   {formErrors.AccountNumber}
                 </small>
               )}
             </div>
 
             <div style={{ display: "flex", flexDirection: "column" }}>
               <label
                style={{ fontWeight: "700", marginBottom: "10px", fontSize:"14px" }}
               >
                 IFSC Code
               </label>
               <input
                 type="text"
                 className="form-control"
                 name="IFSCCode"
                 style={{
                   border: "1px solid #ccc",
                   borderRadius: "5px",
                   padding: "10px",
                   width: "90%",
                 }}
                 value={formData.IFSCCode}
                 onChange={handleInputChange}
               />
               {/* //27/10 */}
               {formErrors.IFSCCode && !ifscMessage && (
                 <small style={{ color: "red", fontWeight: "bold" }}>{formErrors.IFSCCode}</small>
               )}
               {ifscMessage && (
                 <small
                   style={{
                     fontWeight: "800",
                     color: isIfscValid ? "green" : "red",
                   }}
                 >
                   {ifscMessage}
                 </small>
               )}
             </div>
 
             <div style={{ display: "flex", flexDirection: "column" }}>
               <label
                style={{ fontWeight: "700", marginBottom: "10px", fontSize:"14px" }}
               >
                 Branch Name
               </label>
               <input
                 type="text"
                 className="form-control"
                 name="Branch"
                 style={{
                   border: "1px solid #ccc",
                   borderRadius: "5px",
                   padding: "10px",
                   width: "90%",
                 }}
                 value={formData.Branch}
                 onChange={handleInputChange}
               />
               {formErrors.Branch && (
                 <small style={{ color: "red", fontWeight: "bold" }}>
                   {formErrors.Branch}
                 </small>
               )}
             </div>
 
             <div style={{ display: "flex", flexDirection: "column" }}>
               <label
                style={{ fontWeight: "700", marginBottom: "10px", fontSize:"14px" }}
               >
                 Account Holder Name
               </label>
               <input
                 type="text"
                 className="form-control"
                 name="AccountHodlerName"
                 style={{
                   border: "1px solid #ccc",
                   borderRadius: "5px",
                   padding: "10px",
                   width: "90%",
                 }}
                 value={formData.AccountHodlerName}
                 onChange={handleInputChange}
               />
               {formErrors.AccountHodlerName && (
                 <small style={{ color: "red", fontWeight: "bold" }}>
                   {formErrors.AccountHodlerName}
                 </small>
               )}
             </div>
 
             <div style={{ display: "flex", flexDirection: "column" }}>
               {/* //3/11 */}
               <label style={{ fontWeight: "700", marginBottom: "10px", fontSize:"14px" }} >  Deduction Type
               </label>
               <select  className="form-select"
                 name="DeductionID"
                 value={formData.DeductionID}
                 onChange={(e) => {
                   handleInputChange(e);
                   changeOptions(e, e.target.value);
                 }}  style={{
                   border: "1px solid #ccc",
                   borderRadius: "5px",
                   padding: "10px",
                   width: "90%",
                 }}>
                 <option value="" disabled>
                   Select
                 </option>
                 {fetchBanksDetails &&
                   fetchBanksDetails.map((val, index) => (
                     <option key={index} value={val.DeductionID}>
                       {val.Deduction_Name}
                     </option>
                   ))}
               </select>
               {/* //27/10 */}
               {formErrors.DeductionID && (
                 <small style={{ color: "red", fontWeight: "bold" }}>
                   {formErrors.DeductionID}
                 </small>
               )}
             </div>
             
             
           </div>
           {/* //30/10 */}
           <div
           style={{
             display: "flex",
             gap: "20px",
             marginTop: "20px",
             justifyContent: "center",
           }}
         >
           <button
             type="submit"
             style={{
               display: "flex",
               justifyContent: "center",
               alignItems: "center",
               borderRadius: "20px",
               width: "120px",
               height: "40px",
               backgroundColor:" rgb(46, 158, 79)",
               border: "none",
               fontSize: "16px",
               color: "#ffffff",
               fontWeight: "700",
             }}
           >
             {/* //23/10 submit icon*/}
             <img
               src={submit}
               style={{
                 marginRight: "10px",
                 width: "1.2rem",
                 paddingBottom: "3px",
                 fontSize: "15px",
               }}
             />
             {editId ? "Update" : "Submit"}
           </button>
           <button
             onClick={resetData}
             type="button"
             style={{
               display: "flex",
               justifyContent: "center",
               alignItems: "center",
               borderRadius: "20px",
               width: "120px",
               height: "40px",
               backgroundColor: "#ee5d50",
 
               border: "none",
               fontSize: "16px",
               color: "#ffffff",
               fontWeight: "700",
             }}
           >
             {/* //23/10 */}
             <img src={Cancel32} alt="Cancel" style={{ marginRight: "10px", width: "1.2rem", }} />
             Cancel
           </button>
         </div>
         </div>
 
         
      
 
       {tableData && (
         //30/10
          <div
       style={{
         width: "100%",
         background: "#eef1f6",
         borderRadius: "12px",
         padding: "20px 15px",
         boxSizing: "border-box",
         boxShadow: "0 3px 10px rgba(0, 0, 0, 0.10)",
         border: "1px solid #E1E6EF",
         marginTop:"20px"
       }}
     >
       {/* //30/10 */}
       <div
             style={{
               display: "flex",
               justifyContent: "space-between",
               alignItems: "center",
               flexWrap: "wrap",
             marginBottom:"15px"
             }}
           >
             <h5
               style={{  fontWeight: "700", color: "black", fontSize:"18px" }}
             >
               <img
                 src={"/List-32.png"}
                 alt="Project Icon"
                 style={{ marginRight: "10px", width: 28, height: 28 }}
               />
               Add Tax List
             </h5>
             {/* 12-10 for search */}
             <div className="search-container">
               <img src={"/Search-32.png"} alt="Search Icon" className="search-icon" />
               {/* //27/10 */}
               <input type="text" className="search-input" placeholder="Search ..." value={searchTerm} onChange={(e) => {
                 setSearchTerm(e.target.value);
                 setCurrentPage(1);
               }}
               />
             </div>
           </div>
         <div
           style={{
             //30/10
             // marginTop: "50px",
             //   marginLeft: "20px",
             //   width: "100%",
             //  maxWidth: "1130px",
             justifyContent: "center",
             alignItems: "center",
             backgroundColor: "#ffffff",
             boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
             borderRadius: "10px",
             padding: "20px",
           }}
         >
 
           {/* 12-10 for search */}
           
           {/* //30/10 */}
           {/* //3/11 */}
           <div className="sticky-table-wrap" style={{ maxHeight: "300px", overflowY: "auto", overflowX: "auto", border: "1px solid #e6e9ee", borderRadius: "10px", position: "relative" }} >
                     <table  style={{ width: "100%", borderCollapse: "separate",  borderSpacing: 0 }}>
               <thead>
                 <tr
                 //28/10
                   style={{
                     backgroundColor: "#2D79DB",
                     color: "white",
                     fontSize: "14px",
                     fontWeight: "400",
                     textAlign: "center",
                     whiteSpace: "nowrap",
                   }}
                 >
                   <th style={{ padding: "10px" }}>Sr.No</th>
                   <th style={{ padding: "10px" }}>Bank Name</th>
                   <th style={{ padding: "10px" }}>Account Number</th>
                   <th style={{ padding: "10px" }}>IFSC CODE</th>
                   <th style={{ padding: "10px" }}>Branch Name</th>
                   <th style={{ padding: "10px" }}>Account Holder Name</th>
                   <th style={{ padding: "10px" }}>Use For</th>
                   <th style={{ padding: "10px" }}>Actions</th>
                 </tr>
               </thead>
               <tbody>
                 {/* {currentTableData.map((item, index) => ( */}
                 {/* 12-10 for no dara msg */}
 
                 {currentTableData.length > 0 ? (
                   currentTableData.map((item, index) => (
 
                     <tr
                       key={item.id}
                       //28/10
                       style={{
                         backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CDE4F2",
                         height: "50px",
                       }}
                     >
                       <td style={{ padding: "10px", fontWeight: "600" }}>
                         {indexOfFirstRecord + 1 + index}
                       </td>
                       <td
                         style={{
                           padding: "10px",
                           color: "#044c92",
                           fontWeight: "600",
                         }}
                       >
                         {item.Bank_Name}
                       </td>
                       <td style={{ padding: "10px", fontWeight: "600" }}>
                         {item.Account_Number}
                       </td>
                       <td style={{ padding: "10px", fontWeight: "600" }}>
                         {item.IFSC_CODE}
                       </td>
                       <td style={{ padding: "10px", fontWeight: "600" }}>
                         {item.Branch_Name}
                       </td>
                       <td style={{ padding: "10px", fontWeight: "600" }}>
                         {item.AccountHodlerName}
                       </td>
                       <td style={{ padding: "10px", fontWeight: "600" }}>
                         {item.UseFor}
                       </td>
                       <td
                         style={{
                           padding: "10px",
                           display: "flex",
                           alignItems: "center",
                           gap: "5px", // spacing between buttons
                         }}
                       >
                         <button
                           onClick={() => handleEdit(item)}
                           onMouseEnter={() => setHoveredEditId(item.id)} //12-10
                           onMouseLeave={() => setHoveredEditId(null)}//12-10 hover
                           style={{
                             // backgroundColor: isHovered ? "#044c92" : "#ffffff",
                             backgroundColor: hoveredEditId === item.id ? "#044c92" : "#ffffff",//12-10
 
                             border: "1px solid #044c92",
                             // color: isHovered ? "#ffffff" : "#044c92",
                             color: hoveredEditId === item.id ? "#ffffff" : "#044c92", //12-10
                             borderRadius: "5px",
                             // padding: "5px 5px",
                             fontWeight: "700",
                             fontSize: "12px",
                             display: "flex",
                             alignItems: "center",
                           }}
                         >
                           {/* <img
                           // src={isHovered ? Edit32WHITE : EditIcon}
                            src={hoveredEditId === item.id ? Edit32WHITE : EditIcon}//12-10
                           alt="Edit Icon"
                           style={{ marginRight: "0px", width: 25, height: 25 }}
                         /> */}
 
                           {/* //23/10 */}
                           <img
                             src={hoveredEditId === item.id ? Edit32WHITE : EditIcon}
                             style={{
                               marginRight: "4px",
                               width: "16px",
                               height: "16px",
                               maxWidth: "16px",
                               maxHeight: "16px",
                               objectFit: "contain",
                               flexShrink: 0,
                               display: "block",
                             }}
                             alt="Edit Icon"
                           />
                           Edit
                         </button>
                         <button
                           // onClick={(e) => handleDelete(e, item.DeductionID)}27-10
                           onClick={(e) => handleDelete(e, item.id)}
                           // onMouseEnter={() => setIsHovered(true)}
                           // onMouseLeave={() => setIsHovered(false)}
                           // 12-10
                           onMouseEnter={() => setHoveredDeleteId(item.id)}
                           onMouseLeave={() => setHoveredDeleteId(null)}
                           style={{
                             // backgroundColor: isHovered ? "#ee5d50" : "#ffffff",
 
                             backgroundColor: hoveredDeleteId === item.id ? "#ee5d50" : "#ffffff",
                             border: "1px solid #ee5d50",
                             // color: isHovered ? "#ffffff" : "#ee5d50",
                             color: hoveredDeleteId === item.id ? "#ffffff" : "#ee5d50",
                             borderRadius: "5px",
                             // padding: "5px 5px",
                             fontWeight: "700",
                             fontSize: "13px",
                             display: "flex",
                             alignItems: "center",
                           }}
                         >
                           {/* <img
                           // src={isHovered ? Delete32WHITE : DeleteIcon}
                           // 12-10
                           src={hoveredDeleteId === item.id ? Delete32WHITE : DeleteIcon}
                           alt="Delete Icon"
                           style={{ marginRight: "0px", width: 25, height: 25 }}
                         /> */}
 
                           {/* //23/10 */}
                           <img
                             src={hoveredDeleteId === item.id ? Delete32WHITE : DeleteIcon}
                             alt="Delete Icon"
                             style={{
                               marginRight: "4px",
                               width: "16px",
                               height: "16px",
                               maxWidth: "16px",
                               maxHeight: "16px",
                               objectFit: "contain",
                               flexShrink: 0,
                               display: "block",
                             }}
                           />
                           Delete
                         </button>
                       </td>
                       {/* 12-10 for no data msg */}
 
                     </tr>
                   ))
                 ) : (
                   <tr>
                     <td
                       colSpan={8}
                       style={{
                         textAlign: "center",
                         padding: "20px",
                         fontWeight: "600",
                         color: "#666",
                       }}
                     >
                       No data available
                     </td>
                   </tr>
                 )}
 
               </tbody>
             </table>
           </div>
 
           {/* Pagination */}
           <div
             style={{
               display: "flex",
               justifyContent: "space-between",
               alignItems: "center",
               marginTop: "20px",
             }}
           >
             {/* Showing Entries */}
             {/* //27/10 */}
             <div>
               <p style={{ fontSize: "14px", color: "black", margin: 0 }}>
                 Showing{" "}
                 {filteredTableData.length
                   ? Math.min(indexOfFirstRecord + 1, filteredTableData.length)
                   : 0}{" "}
                 to {Math.min(indexOfLastRecord, filteredTableData.length)} of{" "}
                 {filteredTableData.length} entries
               </p>
             </div>
 
             {/* Pagination Controls */}
             <div
               style={{
                 display: "flex",
                 alignItems: "center",
                 gap: "18px",
               }} >
               {/* Previous */}
               <button
                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                 disabled={currentPage === 1}
                 style={{
                   border: "none",
                   background: "transparent",
                   color: currentPage === 1 ? "#999" : "#2ea4e7",
                   cursor: currentPage === 1 ? "not-allowed" : "pointer",
                   fontSize: "13px",
                   padding: 0,
                   display: "flex",
                   alignItems: "center",
                   gap: "4px",
                   opacity: currentPage === 1 ? 0.5 : 1,
                 }}
               >
                 <span style={{ fontSize: "20px" }}>‹</span>
                 Previous
               </button>
 
               {/* Page Numbers */}
               <div
                 style={{
                   display: "flex",
                   alignItems: "center",
                   gap: "20px",
                 }}
               >
                 {getPageNumbers(currentPage, totalPages).map(
                   (pageNumber, index) => {
                     if (pageNumber === "...") {
                       return (
                         <span
                           key={`ellipsis-${index}`}
                           style={{
                             fontSize: "13px",
                             color: "#444",
                           }}
                         >
                           ...
                         </span>
                       );
                     }
 
                     return (
                       <button
                         key={pageNumber}
                         onClick={() => setCurrentPage(pageNumber)}
                         style={{
                           border: "none",
                           background: "transparent",
                           padding: 0,
                           color:
                             currentPage === pageNumber ? "#2ea4e7" : "#444",
                           cursor: "pointer",
                           fontSize: "13px",
                           fontWeight:
                             currentPage === pageNumber ? "600" : "400",
                           textDecoration:
                             currentPage === pageNumber ? "underline" : "none",
                         }}
                       >
                         {pageNumber}
                       </button>
                     );
                   },
                 )}
               </div>
 
               {/* Next */}
               <button
                 onClick={() =>
                   setCurrentPage((prev) => Math.min(prev + 1, totalPages || 1))
                 }
                 disabled={currentPage === totalPages || totalPages === 0}
                 style={{
                   border: "none",
                   background: "transparent",
                   color:
                     currentPage === totalPages || totalPages === 0
                       ? "#999"
                       : "#2ea4e7",
                   cursor:
                     currentPage === totalPages || totalPages === 0
                       ? "not-allowed"
                       : "pointer",
                   fontSize: "13px",
                   padding: 0,
                   display: "flex",
                   alignItems: "center",
                   gap: "4px",
                   opacity:
                     currentPage === totalPages || totalPages === 0 ? 0.5 : 1,
                 }}
               >
                 Next
                 <span style={{ fontSize: "20px" }}>›</span>
               </button>
             </div>
           </div>
         </div>
         </div>
       )}
        </Form>
     </div>
   );
};

export default Banks;
